export const parameters = {
    PASSWORD_EXPIRATION: {
        values: [
            {
                value: 'MENSUAL',
                text: 'Mensual'
            },
            {
                value: 'TRIMESTRAL',
                text: 'Trimestral'
            },
            {
                value: 'SEMESTRAL',
                text: 'Semestral'
            },
            {
                value: 'ANUAL',
                text: 'Anual'
            }
        ]
    },
    RESPONSE_TIME_FOR_MEMBER: {
        values: []
    },
    RESPONSE_TIME_FOR_NO_MEMBER: {
        values: []
    },
    NOTICE_OF_AGREEMENT_TERMINATION: {
        values: []
    },
    NOTICE_OF_MEMBER_UNSUBSCRIBE: {
        values: []
    },
    SEND_LOYALTY_EMAIL: {
        values: []
    },
    SEND_FEE_CERTIFICATE: {
        values: []
    },
    SEND_MEMBERSHIP_CERTIFICATE: {
        values: []
    },
    NOTICE_TO_ACCOUNTING_OF_NEXT_COLLECTION: {
        values: []
    },
    QUERY_RATING_TOKEN_EXPIRATION: {
        values: []
    },
    RETURN_OF_RECEIPTS_PERIOD: {
        values: []
    }
};